import { observer } from 'mobx-react';
import * as React from 'react';
import { TranslationsContext } from '../../../../Translations';
import WaffleDropdown from './WaffleDropdown';

const WaffleSwitcher: React.FC = () => (
  <TranslationsContext.Consumer>
    {(ts) => <WaffleDropdown translationsState={ts} />}
  </TranslationsContext.Consumer>
);

export default observer(WaffleSwitcher);
